import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowUpdateDocumentModal = createSelector(
  [(store: RootState) => store.documentShow.showUpdateDocumentModal],
  (data) => data
);
